import type { Rule } from "antd/lib/form";
import i18n from "i18next";

export const propertyGroupRequiredRule: Rule = {
    validator: (_, dynamicPropertiesValue) => {
        if (dynamicPropertiesValue?.id) {
            return Promise.resolve();
        }
        return Promise.reject(i18n.t("common.input.required.error"));
    },
};
